export const rubros = [
		{
			
			"nombre": "1. Normatividad",
			"icono": "Normatividad.png",
			"formatos": [
				{
					"nombre": "Marco Normativo",
					"xlsx": "f1",
					"html": "f1",
				}
			]
		}, 
		{
			
			"nombre": "2. Estructura",
			"icono":"Estructura.png",
			"formatos": [
				{
					"nombre": "Estructura Orgánica",
					"xlsx": "f2_a",
					"html": "f2_a",
				},
				{
					"nombre": "Organigrama",
					"xlsx": "f2_b",
					"html": "f2_b",
				}
			]
		},
		{
			
			"nombre": "3. Facultades",
			"icono":"Facultades.png",
			"formatos": [
				{
					"nombre": "Facultades",
					"xlsx": "f3",
					"html": "f3",
				}
			]
		},
		{
			
			"nombre": "4. Programas Operativos Anuales",
			"icono":"ProgramasOperativosAnuales.png",
			"formatos": [
				{
					"nombre": "Metas y Objetivos",
					"xlsx": "f4",
					"html": "f4",
				}
			]
			
		},
		{
			
			"nombre": "5. Indicadores de Interés",
			"icono":"IndicadoresInteres.png",
			"formatos": [
				{
					"nombre": "Indicadores de Interés",
					"xlsx": "f5",
					"html": "f5",
				}
			]
			
		},
		{
			
			"nombre": "6. Matriz de Indicadores",
			"icono":"MatrizIndicadores.png",
			"formatos": [
				{
					"nombre": "Matriz de Indicadores",
					"xlsx": "f6",
					"html": "f6",
				}
			]
			
		},
		{
			
			"nombre": "7. Directorio",
			"icono":"Directorio.png",
			"formatos": [
				{
					"nombre": "Directorio",
					"xlsx": "f7",
					"html": "f7",
				}
			]
			
		},
		{
			
			"nombre": "8. Sueldos",
			"icono":"Sueldos.png",
			"formatos": [
				{
					"nombre": "Remuneraciones",
					"xlsx": "f8_a",
					"html": "f8_a",
				},
				{
					"nombre": "Tabulador de Sueldos y Salarios",
					"xlsx": "f8_b",
					"html": "f48_b",
					"xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/8.%20Sueldos",
					"htm_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/a69_f8_bOM.htm",

				},
			]
			
		},
		{
			
			"nombre": "9. Viáticos",
			"icono":"Viaticos.png",
			"formatos": [
				{
					"nombre": "Viáticos",
					"xlsx": "f9",
					"html": "f9",
				}
			]	
		},
		{
			
			"nombre": "10. Plazas",
			"icono":"Plazas.png","formatos": [
				{
					"nombre": "Total de Personal de Base y Confianza",
					"xlsx": "f10_a",
					"html": "f10_a",
				},
				{
					"nombre": "Total de las Plazas de Base y Confianza",
					"xlsx": "f10_b",
					"html": "f10_b",
				}
			]	
		},
		{
			
			"nombre": "11. Honorarios",
			"icono":"Honorarios.png",
			"formatos": [
				{
					"nombre": "Personal de Honorarios",
					"xlsx": "f11",
					"html": "f11",
				}
			]	
		},
		{
			"nombre": "12. Declaraciones Públicas",
			"icono":"DeclaracionesPublicas.png",
			"formatos": [
				/*{
					"nombre": "Opiniones del Consejo Consultivo Ciudadano",
					"xlsx": "f12",
					"html": "f12",
					"xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f12_I_SC.xlsx",
					"htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f12_I_SC.htm",
				}*/
			],
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/12.%20Declaraciones%20P%C3%BAblicas"
		},
		{
			"nombre": "13. Datos de Contacto de la Unidad",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
			/*{
					"nombre": "Domicilio de la Unidad de Transparencia",
					"xlsx": "f13",
					"html": "f13",
					"xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f13_SC.xlsx",
					*/
			],
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/13.%20Datos%20de%20Contacto%20de%20la%20Unidad"
		},
		{
			
			"nombre": "14. Convocatorias",
			"icono":"Convocatorias.png",
			"formatos": [
				{
					"nombre": "Convocatorias a Concursos para Cargos Públicos",
					"xlsx": "f14",
					"html": "f14",
				}
			]
		},
		{
			
			"nombre": "15. Programas Sociales",
			"icono":"ProgramasSociales.png",
			"formatos": [
			/*	{
					"nombre": "Programas de Subsidio, Estimulo y Apoyo",
					"xlsx": "f15_a",
					"html": "f15_a"
				},
				{
					"nombre": "Padrón de beneficiarios",
					"xlsx": "f15_b",
					"html": "f15_b"
				}*/
			],
		    "url" : "https://s-seguridad.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/Programas%20Sociales"
		},
		{
			
			"nombre": "16. Relaciones Laborales",
			"icono":"RelacionesLaborales.png",
			"formatos": [
			/*	{
					"nombre": "Condiciones Generales de Trabajo",
					"xlsx": "f16_a",
					"html": "f16_a"
				},
				{
					"nombre": "Recursos Públicos",
					"xlsx": "f16_b",
					"html": "f16_b"
				}*/
			],
			"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/16.%20Relaciones%20Laborales"
		},
		{
			
			"nombre": "17. Información Curricular",
			"icono":"InformacionCurricular.png",
			"formatos": [
				{
					"nombre": "Información Curricular",
					"xlsx": "f17",
					"html": "f17",
				}
			]
		},
		{
			
			"nombre": "18. Sanciones Administrativas",
			"icono":"SancionesAdministrativas.png",
			"formatos": [
				/*{
					"nombre": "Servidores Públicos Sancionados",
					"xlsx": "f18",
					"html": "f18",
					"xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f18_SC.xlsx",
					"htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f18_SC.htm",
				}*/
			],
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/18.%20Sanciones%20Administrativas"
		},
		{
			
			"nombre": "19. Servicios",
			"icono":"Servicios.png",
			"formatos": [
				{
					"nombre": "Servicios",
					"xlsx": "f19",
					"html": "f19",
				}
			]
			
		},
		{
			
			"nombre": "20. Trámites",
			"icono":"Tramites.png",
			"formatos": [
				{
					"nombre": "Trámites",
					"xlsx": "f20",
					"html": "f20",
				}
			]
			
		},
		{
			
			"nombre": "21. Presupuesto e Informes Trimestrales",
			"icono":"PresupuestoInformesTrimestrales.png",
			"formatos": [
				{
					"nombre": "Presupuesto Anual",
					"xlsx": "f21_a",
					"html": "f21_a",
				},
				{
					"nombre": "Gasto Trimestral",
					"xlsx": "f21_b",
					"html": "f21_b",
				},
				{
					"nombre": "Cuenta Pública",
					"xlsx": "f21_c",
					"html": "f21_c",
				}
			]
			
		},
		{
			
			"nombre": "22. Deuda Pública",
			"icono":"DeudaPublica.png",
			"formatos": [
				/*{
					"nombre": "Deuda Pública",
					"xlsx": "f22",
					"html": "f22"
				}*/
			],
			"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/22.Deuda%20P%C3%BAblica"
			
		},
		{ 
			
			"nombre": "23. Comunicación Social y Publicidad",
			"icono":"ComunicacionSocialPublicidad.png",
			"formatos": [
				{
					"nombre": "Programa Anual de Comunicación Social",
					"xlsx": "f23_a",
					"html": "f23_a",
				},
				{
					"nombre": "Erogación de Recursos de Comunicación Social",
					"xlsx": "f23_b",
					"html": "f23_b",
				},
				{
					"nombre": "Tiempos Oficiales",
					"xlsx": "f23_c",
					"html": "f23_c",
					"xlsx_liga": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.xlsx",
					"htm_liga": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.htm",

				},
				/*{
					"nombre": "Información Relacionada a Tiempos Oficiales",
					"xlsx": "f23_d",
					"html": "f23_d",
					"xlsx_liga": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/2023/Transparencia/xlsx/a69_f23_d_RTVH.xlsx",
					"htm_liga": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/2023/Transparencia/htm/a69_f23_d_RTVH.htm"
				},*/

			]
		},
		{
			
			"nombre": "24. Resultados de Auditorías",
			"icono":"ResultadosAuditorias.png",
			"formatos": [
            	/*{
					"nombre": "Auditorías",
					"xlsx": "f24",
					"html": "f24",
					"xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f24_SC.xlsx",
					"htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f24_SC.htm",
				} */
			],
				"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/24.%20Resultados%20de%20Auditor%C3%ADas"
		},
		{
			
			"nombre": "25. Dictámenes de Estados Financiero",
			"icono":"DictamenesFinancieros.png",
			"formatos": [
				{
					"nombre": "Dictámines de Estados Financieros",
					"xlsx": "f25",
					"html": "f25",
				}
			]
			
		},
		{
			
			"nombre": "26. Asignación de Recursos Públicos a Personas",
			"icono":"AsignacionRecursosPublicosPersonas.png",
			"formatos": [
				{
					"nombre": "Personas a Quienes se asignó Recursos Públcios",
					"xlsx": "f26",
					"html": "f26",
				}
			]	
		},
		{
			
			"nombre": "27. Concesiones",
			"icono":"Concesiones.png",
			"formatos": [
				{
					"nombre": "Resultados de procedimientos de adjudicación directa, licitación pública e invitación restringida",
					"xlsx": "f27",
					"html": "f27",
				}
			]
			
		},
		{
			
			"nombre": "28. Licitaciones Públicas",
			"icono":"LicitacionesPublicas.png",
			"formatos": [
				{
					"nombre": "Procedimientos de Licitación Pública e Invitación a Cuando Menos Tres Personas",
					"xlsx": "f28",
					"html": "f28",
				},

			]
			
		},
		{
			
			"nombre": "29. Informes",
			"icono":"Informes.png",
			"formatos": [
				{
					"nombre": "Informes",
					"xlsx": "f29",
					"html": "f29",
				}
			]
			
		},
		{
			
			"nombre": "30. Estadísticas Generadas",
			"icono":"EstadisticasGenerales.png",
			"formatos": [
				{
					"nombre": "Estadísticas",
					"xlsx": "f30",
					"html": "f30",
				}
			]
			
		},
		{
			
			"nombre": "31. Informe de Avances y Documentos Financieros",
			"icono":"InformeAvancesDocumentosFinancieros.png",
			"formatos": [
				{
					"nombre": "Informe de Estados Financieros",
					"xlsx": "f31_a",
					"html": "f31_a",
				},
				{
					"nombre": "Informe Contable, Presupuestal y Programático",
					"xlsx": "f31_b",
					"html": "f31_b",
				}
			]
			
		},
		{
			
			"nombre": "32. Padrón de Proveedores y Contratistas",
			"icono":"PadronProveedoresContratistas.png",
			"formatos": [
				/*{
					"nombre": "Padrón de Proveedores y Contratistas",
					"xlsx": "f32",
					"html": "f32",
					"xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f32_SC.xlsx",
					"htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f32_SC.htm"
				}*/
			],	
		"url" :	"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/32.%20Padr%C3%B3n%20de%20Proveedores%20y%20Contratistas"	
		},
		{
			
			"nombre": "33. Convenios con Sectores Social y Privado",
			"icono":"ConveniosSectoresSocialPrivado.png",
			"formatos": [
				{
					"nombre": "Convenios de Coordinación y Concertación",
					"xlsx": "f33",
					"html": "f33",
				}
			]
			
		},
		{
			
			"nombre": "34. Inventario de Bienes",
			"icono":"InventarioBienes.png",
			"formatos": [
				{
					"nombre": "Inventario de Bienes Muebles",
					"xlsx": "f34_a",
					"html": "f34_a",
				},
				{
					"nombre": "Alta de Bienes Muebles",
					"xlsx": "f34_b",
					"html": "f34_b",
				},
				{
					"nombre": "Bajas de Bienes Muebles",
					"xlsx": "f34_c",
					"html": "f34_c",
				},
				{
					"nombre": "Inventario de Bienes Inmuebles",
					"xlsx": "f34_d",
					"html": "f34_d",
				},
				{
					"nombre": "Alta de Bienes Inmuebles",
					"xlsx": "f34_e",
					"html": "f34_e",
				},
				{
					"nombre": "Bajas de Bienes Inmuebles",
					"xlsx": "f34_f",
					"html": "f34_f",
				},
				{
					"nombre": "Donaciones de Bienes Muebles e Inmuebles",
					"xlsx": "f34_g",
					"html": "f34_g",
				}

			]
			
		},
		{
			
			"nombre": "35. Recomendaciones y Atención en Materia de Derechos Humanos",
			"icono":"RecomendacionesAtenciónMateriaDerechosHumanos.png",
			"formatos": [
				{
					"nombre": "Recomendaciones de Derechos Humanos Emitidas por la CNDH",
					"xlsx": "f35_a",
					"html": "f35_a",
				},
				{
					"nombre": "Recomendaciones de Derechos Humanos Casos Especiales",
					"xlsx": "f35_b",
					"html": "f35_b",
				},
				{
					"nombre": "Las Recomendaciones de Derechos Humanos Org. Int. CNDH",
					"xlsx": "f35_c",
					"html": "f35_c",
				},
			]
			
		},
		{
			
			"nombre": "36. Resoluciones y Laudos de Juicios",
			"icono":"ResolucionesLaudosJuicios.png",
			"formatos": [
				/*{
					"nombre": "Resoluciones y Laudos ",
					"xlsx": "f36",
					"html": "f36",
					"xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f36_SC.xlsx",
					"htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f36_SC.htm",
				}*/
			],
		"url" :	"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/36.%20Resoluciones%20y%20Laudos%20de%20Juicios"			
		},
		{
			
			"nombre": "37. Mecanismo de Participación Ciudadana",
			"icono":"MecanismosParticipacionCiudadana.png",
			"formatos": [
				{
					"nombre": "Mecanismos de Participación Ciudadana",
					"xlsx": "f37_a",
					"html": "f37_a",
				},
				{
					"nombre": "Resultados de los Mecanismos de Participación Ciudadana",
					"xlsx": "f37_b",
					"html": "f37_b",
				}
			]
			
		},
		{
			
			"nombre": "38. Programas Ofrecidos",
			"icono":"ProgramasOfrecidos.png",
			"formatos": [
				/*{
					"nombre": "Programas que Ofrecen",
					"xlsx": "f38_a",
					"html": "f38_a"
				},
				{
					"nombre": "Tramites a los Programas que Ofrecen",
					"xlsx": "f38_b",
					"html": "f38_b",
				}*/
			],
		"url" : "https://s-salud.hidalgo.gob.mx/Transparencia/RubrosSsh/DetalleRubroSsh/38.%20Programas%20Ofrecidos"
			
		},
		{
			
			"nombre": "39. Actas y Resoluciones del Comité de Transparencia",
			"icono":"ActasResolucionesComiteTransparencia.png",
			"formatos": [
			/*{
					"nombre": "Informe de Sesiones",
					"xlsx": "f39_a",
					"html": "f39_a",
					"xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f39a_SC.xlsx",
					"htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f39a_SC.htm",
				},
				{
					"nombre": "Informe de Resoluciones",
					"xlsx": "f39_b",
					"html": "f39_b",
					"xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f39b_SC.xlsx",
					"htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f39b_SC.htm",
				},
				{
					"nombre": "Actas Integrantes del Comité",
					"xlsx": "f39_c",
					"html": "f39_c",
					"xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f39c_SC.xlsx",
					"htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f39c_SC.htm",
				},
				{
					"nombre": "Calendario de Sesiones del comité",
					"xlsx": "f39_d",
					"html": "f39_d",
					"xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f39d_SC.xlsx",
					"htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f39d_SC.htm",
				}*/
			],
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/39.%20Actas%20y%20Resoluciones%20del%20Comit%C3%A9%20de%20Transparencia"			
		},
		{
			
			"nombre": "40. Evaluacion y Encuesta a Programas Financiados con Recursos Públicos",
			"icono":"EvaluacionencuestasProgramas.png",
			"formatos": [
				/*{
					"nombre": "Evaluaciones",
					"xlsx": "f40_a",
					"html": "f40_a"
				},
				{
					"nombre": "Encuestas",
					"xlsx": "f40_b",
					"html": "f40_b"
				}*/
			],
		"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/40.Evaluacion%20y%20Encuestas%20a%20Programas%20Financiados%20con%20Recursos%20P%C3%BAblicos"	
			
		},
		{
			
			"nombre": "41. Estudios Pagados con Recursos Públicos",
			"icono":"EstudiosPagadosRecursosPublicos.png",
			"formatos": [
				{
					"nombre": "Estudios Pagados con Recursos Públicos ",
					"xlsx": "f41",
					"html": "f41",
				}
			]
			
		},
		{
			
			"nombre": "42. Listados Jubilados y Pensionados",
			"icono":"ListadoJubiladosPencionados.png",
			"formatos": [
			/*	{
					"nombre": "Jubilados y Pensionados Leyenda",
					"xlsx": "f42_a",
					"html": "f42_a"
				},
				{
					"nombre": "Jubilados y Pensionados Listado",
					"xlsx": "f42_b",
					"html": "f42_b"
				}*/
			],
		"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/42.%20Listados%20Jubilados%20y%20Pensionados"
	},
		{
			
			"nombre": "43. Ingresos Recibidos por Cualquier Concepto",
			"icono":"IngresosRecibidosCualquierConcepto.png",
			"formatos": [
				{
					"nombre": "Ingresos Recibidos",
					"xlsx": "f43_a",
					"html": "f43_a",
				},
				{
					"nombre": "Responsables de Recibir los Ingresos",
					"xlsx": "f43_b",
					"html": "f43_b",
				}
			]	
			
		},
		{
			
			"nombre": "44. Donaciones Hechas a Terceros",
			"icono":"DonacionesHechasTerceros.png",
			"formatos": [
				{
					"nombre": "Donaciones hechas a Terceros en Dineros",
					"xlsx": "f44_a",
					"html": "f44_a",
				},
				/*{
					"nombre": "Donaciones Hechas a Terceros en Especie",
					"xlsx": "f44_b",
					"html": "f44_b"
				}*/
			]	
			
		},
		{
			
			"nombre": "45. Catálogo Documental y Guía de Archivos",
			"icono":"Viaticos.png",
			"formatos": [
				{
					"nombre": "Inventarios documentales",
					"xlsx": "f45_a",
					"html": "f45_a",
				},
				{
					"nombre": "Índice de expedientes clasificados",
					"xlsx": "f45_b",
					"html": "f45_b",
					"xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f45b_SC.xlsx",
					"htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f45b_SC.htm",

				},
				{
					"nombre": "Cuadro de clasificación archivística",
					"xlsx": "f45_c",
					"html": "f45_c",
				}
			],			
		},
		{
			
			"nombre": "46. Actas de Sesiones, Opiniones y Recomendaciones de Consejos Consultivos",
			"icono":"CatalogoDocumentalGuiaArchivos.png",
			"formatos": [
				/*{
					"nombre": "Actas del Consejo Consultivo Ciudadano",
					"xlsx": "f46_a",
					"html": "f46_a",
					"xlsx_liga": "https://s-turismo.hidalgo.gob.mx/Transparencia/xlsx/a69_f46_a_SECTURH.xlsx",
					"htm_liga": "https://s-turismo.hidalgo.gob.mx/Transparencia/htm/a69_f46_a_SECTURH.htm",
				},
				{
					"nombre": "Opiniones del Consejo Consultivo Ciudadano",
					"xlsx": "f46_b",
					"html": "f46_b",
					"xlsx_liga": "https://s-turismo.hidalgo.gob.mx/Transparencia/xlsx/a69_f46b_SECTURH.xlsx",
					"htm_liga": "https://s-turismo.hidalgo.gob.mx/Transparencia/htm/a69_f46b_SECTURH.htm",
				}*/
			],
		"url" : "https://s-turismo.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/46.Actas%20de%20Sesiones,%20Opiniones%20y%20Recomendaciones%20de%20Consejos%20Consultivos"
			
		},
		{
			
			"nombre": "47. Solicitud de Intervención de  Comunicaciones",
			"icono":"SolicitudIntervencionComunicaciones.png",
			"formatos": [
				/*{
					"nombre": "Intervenciones de comunicaciones",
					"xlsx": "f47_a",
					"html": "f47_a"
				},
				{
					"nombre": "Localización Geográfica",
					"xlsx": "f47_b",
					"html": "f47_b"
				},
				{
					"nombre": "Mensaje de Solicitudes a empresas para la intervención de comunicaciones privadas",
					"xlsx": "f47_c",
					"html": "f47_c"
				}*/
			],
		"url" : "https://procuraduria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/Solicitud%20de%20Intervenci%C3%B3n%20de%20%20Comunicaciones"
			
		},
		{
			
			"nombre": "48. Información de Utilidad o Relevante",
			"icono":"InformacionUtilidadRelevante.png",
			"formatos": [
				{
					"nombre": "Interés Público",
					"xlsx": "f48_a",
					"html": "f48_a",
				},
				{
					"nombre": "Preguntas Frecuentes",
					"xlsx": "f48_b",
					"html": "f48_b",
				},
				{
					"nombre": "Transparencia Proactiva",
					"xlsx": "f48_c",
					"html": "f48_c",
				}
			],
			
		},
]